// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Italy from '../_raw/flag/icon_flag_italy.png';

export default () => <img src={Italy} alt="Italy" />;
